<script>
    export default {
        name: "StatusOrderModelProgress",
        props: {
            progress: String,
        },
    };
</script>

<template>
    <div class="b-status__success">
        <div class="b-status__progress">
            <div
                class="b-status__progress-item"
                :class="{
                    'b-status__progress-item--active': [
                        'in_processing',
                        'finish',
                        'in_delivery',
                        'sent',
                    ].includes(progress),
                }"
            >
                <div class="b-status__progress-box">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                        <use
                            xlink:href="/static/assets/status-order/icons.svg#processing"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        ></use>
                    </svg>
                </div>
                Обработка
            </div>
            <div
                class="b-status__progress-item"
                :class="{
                    'b-status__progress-item--active': [
                        'finish',
                        'in_delivery',
                        'sent',
                    ].includes(progress),
                }"
            >
                <div class="b-status__progress-box">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                        <use
                            xlink:href="/static/assets/status-order/icons.svg#sent"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        ></use>
                    </svg>
                </div>
                Отправлен
            </div>
            <div
                class="b-status__progress-item"
                :class="{
                    'b-status__progress-item--active': ['finish', 'in_delivery'].includes(
                        progress
                    ),
                }"
            >
                <div class="b-status__progress-box">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                        <use
                            xlink:href="/static/assets/status-order/icons.svg#delivering"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        ></use>
                    </svg>
                </div>
                В пути
            </div>
            <div
                class="b-status__progress-item"
                :class="{ 'b-status__progress-item--active': progress === 'finish' }"
            >
                <div class="b-status__progress-box">
                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                        <use
                            xlink:href="/static/assets/status-order/icons.svg#finish"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        ></use>
                    </svg>
                </div>
                Доставлен
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .b-status__row {
        display: flex;
        justify-content: space-between;

        &:not(:first-child) {
            padding-top: 12px;
            margin-top: 12px;
            border-top: 1px solid var(--primary-border);
        }
    }

    .b-status__cell {
        font-size: 16px;
        line-height: 24px;
        color: var(--primary-text--light);
    }

    .b-status__progress {
        display: flex;
        justify-content: space-between;
        margin: 24px -4px 24px;
    }

    .b-status__progress-item {
        margin: 0 4px;
        font-size: 12px;
        line-height: 16px;
        color: var(--primary-text--light);
        text-align: center;
        transition: color 0.2s ease-in;
        @include bp($bp-mobile-sm) {
            font-size: 13px;
        }
    }

    .b-status__progress-box {
        display: flex;
        align-items: center;
        justify-content: center;
        @include box(60px);
        background-color: $status-progress-fill;
        margin: 0 auto 4px;
        border-radius: 50%;
        transition: background-color 0.2s ease-in;

        svg {
            fill: $status-progress-fill-svg--active;
        }
        @include bp($bp-mobile-sm) {
            @include box(68px);
        }
    }

    .b-status__progress-item--active {
        color: var(--primary-text);

        .b-status__progress-box {
            background-color: $status-progress-fill--active;

            svg {
                fill: var(--base-white);
            }
        }
    }
</style>
